<template>
    <div :class="'item col-sm-4 col-xs-12 ' + viewmode">
        <div class="product">
            <div class="image" style="height: 200px !important;">

                <a :href="product.url">
                    <div
                            v-if="product.ecommerce && product.ecommerce.free_transport"
                            :class="'imgfreeship_' + locale">


                    </div>

                    <img v-if="product.attachments.length === 0"
                         src="/acm3_core/img/image_broken.png"
                         class="img-responsive"
                    />
                    <img v-else
                         :src="'/' + product.attachments[0].url + '?fit=fill&w=200&h=200'"
                         class="img-responsive"
                    />
                </a>
            </div>
            <div class="description">
                <h4><a :href="product.url" v-bind:title="product.sku">{{product.additional_description |
                    striphtml}}</a></h4>


                <div class="list-description">
                    <p>{{product.truncated_description | striphtml}} </p>
                </div>
                <!-- <span class="size">XL / XXL / S </span>-->
            </div>
            <div
                    v-if="product.ecommerce"
                    class="price"
            >
                <span>{{product.ecommerce.price}}</span>
            </div>
            <div
                    v-else
                    class="price"
            >
                N.D.
            </div>
            <div class="action-control">
                <form
                        :action="getAddToCartLink(product)"
                        method="get"
                >
                    <button
                            class="btn btn-primary"
                            type="submit"
                    >
                        <span class="glyphicon glyphicon-shopping-cart"> </span> {{ $t('message.Aggiungi al carrello') }}
                    </button>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'product-item',
        props: ['product', 'viewmode'],
        data() {
            return {
                isLoading: false,
                locale: this.$i18n.locale
            }
        },
        methods: {
            canAddToCart: function (product) {

                return true;
            },
            getAddToCartLink: function (product) {

                let productCleaned = (product.sku).replace("%2F", '^');
                productCleaned = (productCleaned).replace("/", '^');

                const addToCardLink = product.folder_code != ''
                    ? product.url
                    :

                    product.url
                return addToCardLink;
            }
        }
    }
</script>

<style scoped>

</style>
